export enum FeatureToggle {
  ordersOperationalDashboard = 'rt_orders_operational_dashboard',
  businessOrderingTool = 'rt_business_ordering_tool',
  ordersSearchTableTotalChargeEnabled = 'rt_ops_dashboard_orders_search_table_total_charge_enabled',
  ordersSearchTableTotalChargeBackendValueEnabled = 'rt_ops_dashboard_orders_search_table_total_charge_backend_value_enabled',
}
